<template>
    <grid class="work-orders-job-types" ref="grid" :columnDefs="columnDefs" :fetchCallback="fetchCallback">
        <busy-modal :show="busy" :overlay="true"></busy-modal>
        <div class="work-orders-job-types__toolbar">
            <responsive-button
                :icon="['fas', 'file-excel']"
                :href="exportExcelHref"
                @click="generatingExcelReportSuccessToast"
                variant="primary"
            ></responsive-button>
            <responsive-button :icon="['fas', 'arrows-rotate']" @click="refresh" variant="primary"
                >Refresh</responsive-button
            >
            <responsive-button :icon="['fas', 'plus']" variant="primary" @click="openModal('create')"
                >Add New Job Type</responsive-button
            >
        </div>
        <work-order-job-type-modal
            :modalType="modalType"
            :jobTypeItem="jobTypeItem"
            @hide="onModalHide"
            @ok="onJobTypeSave"
        ></work-order-job-type-modal>
    </grid>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import API from './../../../api';
    import Modal from '../../generic/modal/modal.vue';
    import Grid from '../../generic/grid/grid.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import ActionsCellRenderer from './actions-cell-renderer.vue';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import WorkOrderJobTypeModal from './work-order-job-type-modal.vue';

    const MODAL_TIMEOUT = 200;

    export default {
        name: 'WorkOrdersJobTypes',
        components: {
            Modal,
            Grid,
            ResponsiveButton,
            FormInput,
            BusyModal,
            actionsCellRenderer: ActionsCellRenderer,
            WorkOrderJobTypeModal,
        },
        data() {
            return {
                jobTypeItem: {},
                modalType: '',
                offset: 0,
                limit: 20,
                sort: 'id',
                search: '',
                busy: false,
                validationError: '',
                desc: true,
                columnDefs: [
                    {
                        field: 'id',
                        headerName: 'ID',
                        maxWidth: 80,
                        sort: 'asc',
                    },
                    {
                        field: 'title',
                        headerName: 'Title',
                        flex: 1,
                    },
                    {
                        headerName: '',
                        minWidth: 150,
                        maxWidth: 150,
                        resizable: false,
                        sortable: false,
                        cellStyle: { textAlign: 'center' },
                        cellRenderer: 'actionsCellRenderer',
                        cellRendererParams: {
                            modalData: {
                                openEditModal: this.openModal,
                                onDelete: this.onDelete,
                            },
                            cellType: 'job-types',
                        },
                    },
                ],
            };
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
            exportExcelHref() {
                return encodeURI(
                    `/app/work-orders/api/job-types/grid/excel/?offset=${this.offset}&limit=${this.limit}&sort=${this.sort}&desc=${this.desc}&search=${this.search}`
                );
            },
            isSaveDisabled() {
                return Boolean(this.validationError);
            },
            modalTitle() {
                return this.modalType === 'create' ? 'Add Job Type' : 'Edit Job Type';
            },
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;

                    return API.get('/app/work-orders/api/job-types/grid/', {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                        },
                    });
                };
            },
        },
        methods: {
            setValidationError(errors) {
                this.validationError = errors[0];
                return errors[0];
            },
            openModal(modalType, data) {
                this.modalType = modalType;
                if (modalType === 'edit') {
                    this.jobTypeItem = data;
                }
                this.$bvModal.show('work-orders-job-types-modal');
            },
            onJobTypeSave(values) {
                if (this.modalType === 'edit') {
                    this.onUpdate(values.id, values.title);
                }
                if (this.modalType === 'create') {
                    this.onCreate(values.title);
                }
            },
            onModalHide() {
                this.$bvModal.hide('work-orders-job-types-modal');
                setTimeout(() => {
                    this.jobTypeItem = {};
                }, MODAL_TIMEOUT);
            },
            async onDelete(item) {
                await this.dispatchRequest(
                    () => API.delete(`/app/work-orders/api/job-types/${item.id}/`),
                    `Could not delete job type '${item.title}'.`
                );
            },
            async onCreate(title) {
                await this.dispatchRequest(
                    () =>
                        API.post(`/app/work-orders/api/job-types/`, {
                            title,
                        }),
                    `Could not create new job type.`
                );
            },
            async onUpdate(id, title) {
                await this.dispatchRequest(
                    () =>
                        API.patch(`/app/work-orders/api/job-types/${id}/`, {
                            title,
                        }),
                    `Could not update job type '${title}'.`
                );
            },
            async dispatchRequest(request, errorMessage) {
                this.$bvModal.hide('work-orders-job-types-modal');
                try {
                    this.busy = true;
                    await request();
                } catch {
                    this.errorToast({ text: errorMessage });
                } finally {
                    this.busy = false;
                    this.refresh();
                }
            },
            refresh() {
                this.$refs.grid.refreshDataSource();
            },
        },
    };
</script>

<style lang="scss" scoped></style>
